// extracted by mini-css-extract-plugin
export var link = "_tq-0";